<template>
  <div></div>
</template>

<script>
export default {
  name: "tool-edit-info-base-info",
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>